import ReactQuill from 'react-quill'

// Forma mínima da API do Parchment do Quill 1.x que o react-quill realmente embute em tempo de
// execução (o `.d.ts` dele tipa isto contra o quill@2.x, que tem outro formato).
interface IQuillStyleAttributor {
  whitelist?: string[]
  value(node: HTMLElement): string
}

interface IQuillParchment {
  Attributor: {
    Style: new (
      attrName: string,
      keyName: string,
      options: { scope: number; whitelist: string[] }
    ) => IQuillStyleAttributor
  }
  Scope: {
    BLOCK: number
  }
}

interface IQuillStatic {
  import(name: 'parchment'): IQuillParchment
  register(definition: IQuillStyleAttributor, overwrite?: boolean): void
}

/** As alturas de linha que o editor do blog oferece. Espelha o token `post` do registry. */
export const LINE_HEIGHTS = ['1.0', '1.15', '1.2', '1.5', '2.0']

// O react-quill traz a própria instância do Quill, então o atributo precisa ser registrado nela
// (e não no pacote `quill` de topo) para o controle da barra funcionar de verdade.
const QuillEditor = ReactQuill.Quill as unknown as IQuillStatic
const Parchment = QuillEditor.import('parchment')
const LineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', {
  scope: Parchment.Scope.BLOCK,
  whitelist: LINE_HEIGHTS
})

// O navegador normaliza valores CSS "redondos" ao lê-los de volta por `node.style` ("line-height:
// 2.0" volta como "2"), o que quebra a comparação exata da whitelist e descarta o formato em
// silêncio ao reabrir um post salvo. A comparação numérica é o que reconhece o valor de novo.
const originalLineHeightValue = LineHeightStyle.value.bind(LineHeightStyle)
LineHeightStyle.value = (node: HTMLElement) => {
  const exactMatch = originalLineHeightValue(node)
  if (exactMatch) return exactMatch

  const rawValue = node.style.lineHeight
  if (!rawValue) return ''

  const numericValue = parseFloat(rawValue)
  const whitelistMatch = (LineHeightStyle.whitelist || []).find((allowed) => parseFloat(allowed) === numericValue)
  return whitelistMatch || ''
}

QuillEditor.register(LineHeightStyle, true)
